"use strict";

/* eslint no-console: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Namespace = _interopRequireDefault(require("hublabs-core/Namespace"));

var _utils = require("./utils");

// makeNamespace
// ---
// The fact that hublabs uses classical inheritance to construct namespaces & experiments is an implementation detail.
// The goal of makeNamespace is to:
//  1. Abstract away classes as an implementation detail of hublabs.
//  2. Abstract away boilerplate to creating a namespace.
//  3. Add sane defaults to namespace options.
var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'GenericNamespace' : _ref$name,
      _ref$segments = _ref.segments,
      segments = _ref$segments === void 0 ? 100 : _ref$segments,
      _ref$identifier = _ref.identifier,
      identifier = _ref$identifier === void 0 ? null : _ref$identifier,
      _ref$setupExperiments = _ref.setupExperiments,
      _setupExperiments = _ref$setupExperiments === void 0 ? function () {} : _ref$setupExperiments,
      _ref$allowAutoExposur = _ref.allowAutoExposureLogging,
      allowAutoExposureLogging = _ref$allowAutoExposur === void 0 ? true : _ref$allowAutoExposur,
      _ref$allowedOverride = _ref.allowedOverride,
      allowedOverride = _ref$allowedOverride === void 0 ? null : _ref$allowedOverride,
      _ref$getOverrides = _ref.getOverrides,
      getOverrides = _ref$getOverrides === void 0 ? null : _ref$getOverrides,
      _ref$extraOpts = _ref.extraOpts,
      extraOpts = _ref$extraOpts === void 0 ? {} : _ref$extraOpts;

  var Namespace =
  /*#__PURE__*/
  function (_HublabsNamespace) {
    (0, _inherits2.default)(Namespace, _HublabsNamespace);

    function Namespace() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      (0, _classCallCheck2.default)(this, Namespace);
      args.app = 'hubspot';
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Namespace).call(this, args));
    }

    (0, _createClass2.default)(Namespace, [{
      key: "setup",
      value: function setup() {
        if (name) {
          this.setName(name);
        }

        if (identifier) {
          this.setIdentifier();
        }

        if (segments && typeof segments === 'number') {
          this.setSegments();
        }

        if ((0, _utils.isFunction)(allowedOverride) && (0, _utils.isFunction)(getOverrides)) {
          this.allowedOverride = allowedOverride.bind(this);
          this.getOverrides = getOverrides.bind(this);
        } else if (allowedOverride || getOverrides) {
          console.warn('Hublabs warning - to set global overrides, both the "allowedOverride" & "getOverrides" functions must be defined.');
        }

        this.setAutoExposureLogging(allowAutoExposureLogging);
      }
    }, {
      key: "setIdentifier",
      value: function setIdentifier() {
        // hublabs normally defaults this to (unit = user_id), aka the ID set
        // in registerUser().
        // If you add `identifier: SOME_ID` to your namespace, it will be the
        // source of truth instead.
        // Example - see `NewUserActivationNamespace`
        this.setPrimaryUnit('namespace_identifier');
        this.inputs.namespace_identifier = identifier;
      }
    }, {
      key: "setSegments",
      value: function setSegments() {
        // hublabs defaults this to 100
        this.numSegments = segments;
      }
    }, {
      key: "setupExperiments",
      value: function setupExperiments() {
        if (_setupExperiments && typeof _setupExperiments === 'function') {
          _setupExperiments(this.addExperiment.bind(this), this.removeExperiment.bind(this));
        }
      }
    }]);
    return Namespace;
  }(_Namespace.default);

  return new Namespace(extraOpts);
};

exports.default = _default;
module.exports = exports.default;